import { useEffect } from 'react';
import { ANIMATION_CONFIG } from '../config/constants';
import { scrollToElement } from '../utils/scrollUtils';

const SAME_PAGE_HASH_LINK_SELECTOR = 'a[href^="#"]:not([href="#"])';
const ANCHOR_SCROLL_OFFSET = 24;

export default function useSmoothScroll() {
  useEffect(() => {
    const handleAnchorClick = event => {
      if (event.defaultPrevented) return;

      const link = event.target.closest(SAME_PAGE_HASH_LINK_SELECTOR);
      if (!link) return;

      const targetId = decodeURIComponent(link.hash.slice(1));
      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      window.history.pushState(null, '', link.hash);

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (prefersReducedMotion) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        return;
      }

      const sectionOffset = parseFloat(
        window
          .getComputedStyle(target)
          .getPropertyValue('--anchor-scroll-offset')
      );
      scrollToElement(
        target,
        ANIMATION_CONFIG.SCROLL_DURATION,
        Number.isFinite(sectionOffset) ? sectionOffset : ANCHOR_SCROLL_OFFSET
      );
    };

    document.addEventListener('click', handleAnchorClick);

    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);
}
